import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import DiscoveryButton from './DiscoveryButton';

const CONTENT_PAGE_PATTERNS = [
  /^\/blog\/[^/]+\/\d+/,
  /^\/article\/[^/]+\/\d+/,
];

const DiscoveryNavButton: React.FC = () => {
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const isHome = pathname === '/';
  const isContentPage = CONTENT_PAGE_PATTERNS.some(p => p.test(pathname));

  const fetchAndNavigate = async () => {
    const url = isHome
      ? '/api/surprise/'
      : `/api/surprise/?exclude=${encodeURIComponent(pathname)}`;
    const res = await fetch(url);
    if (!res.ok) return;
    const data = await res.json();
    navigate(data.url);
  };

  return (
    <DiscoveryButton
      show={isHome || isContentPage}
      label={isHome ? '✦ Take Me Somewhere Random' : '✦ Next Place, Please'}
      loadingLabel={isHome ? 'Finding Something…' : 'Finding somewhere…'}
      fetchAndNavigate={fetchAndNavigate}
    />
  );
};

export default DiscoveryNavButton;
